const GiftCard = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card" */ '@/pages/financial/discount/gift-card/index'
  )
const CreateGiftCard = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card" */ '@/pages/financial/discount/gift-card/create.vue'
  )
const GenerateGiftCard = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card" */ '@/pages/financial/discount/gift-card/generate.vue'
  )
const EditGiftCard = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card" */ '@/pages/financial/discount/gift-card/edit.vue'
  )

export default {
  path: 'gift-card',
  meta: {
    label: 'giftCards',
    auth: 'giftCard'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialDiscountGiftCard',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: GiftCard
    },
    {
      name: 'FinancialCreateDiscountGiftCard',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateGiftCard
    },
    {
      name: 'FinancialGenerateDiscountGiftCard',
      path: 'generate',
      meta: {
        label: 'GenerateGiftCard',
        auth: 'generate'
      },
      component: GenerateGiftCard
    },
    {
      name: 'FinancialEditDiscountGiftCard',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditGiftCard,
      props: true
    }
  ]
}
